export default "__VITE_ASSET__7roaUebf__"